/*
	Download IDs switch for Adobe Target Client Side test
*/

var targetABTestDownloadIDs = targetABTestDownloadIDs || (function(){
	'use strict';

	var parameters = {};

	return {
		init: function(params) {
			// default data-role="download-link"
			parameters = params;
		},
		run: function() {
			try {
				var testDownloadID = window.ttMETA && window.ttMETA[0].CampaignId !== '' ? '-' +window.ttMETA[0].CampaignId + '-' + window.ttMETA[0].RecipeName : '',
					buttons = document.querySelectorAll(parameters.query),
					buttonsArray = [];

				// array of buttons object
				buttons.forEach(function(button) {
					if (window.ttMETA && window.ttMETA[0].CampaignId !== '' ) {
						setButton(button);
					} else {
						button.addEventListener('mouseover', function() {
							secondTry()
						})
					}
				})

				// another try to look for ttMETA if it is not ready while init 
				function secondTry() {
					if (window.ttMETA && window.ttMETA[0].CampaignId !== '' ) {
						testDownloadID = '-' + window.ttMETA[0].CampaignId + '-' + window.ttMETA[0].RecipeName;

						buttons.forEach(function(button) {
							button.removeEventListener('mouseover', function() {
								secondTry()
							});
							setButton(button);
						})

						checkConsent(buttonsArray);
					}
				}

				// set button's default and test parameters and push it into buttonsArray
				function setButton(button) {
					// set direct=1 parameter for direct download using download popup
					if ((!button.getAttribute('data-behavior') || button.getAttribute('data-behavior') && button.getAttribute('data-behavior').toLowerCase() !== 'downloadpage') && !avastGlobals.detect.os.isAndroid && !avastGlobals.detect.os.isIOS) {
						var url = new URL(button.href),
							params = url ? url.searchParams : null;

						params.set('direct', 1);
						url.search = params.toString();
						button.href = url.toString();
					}

					var tempID = button.getAttribute('data-download-name'),
						tempHref = button.getAttribute('href');

					buttonsArray.push({
						'el': button,
						'defaultID': tempID.search(testDownloadID) === -1 ? tempID : tempID.replace(testDownloadID, ''),
						'defaultHref': tempHref.search(testDownloadID) === -1 ? tempHref : tempHref.replace(testDownloadID, ''),
						'testID': tempID.search(testDownloadID) === -1 ? tempID + testDownloadID : tempID,
						'testHref': tempHref.search(testDownloadID) === -1 ? tempHref.replace(tempID, tempID + testDownloadID) : tempHref
					})
				};

				// check for
				function checkConsent(btnArray) {
					// check for cookie consent, then replace download IDs with testing one, else replace it with default one
					if(window.cheq && window.cheq.getConsentCookies.performance === '1') {
						btnArray.forEach(function(buttonObj) {
							buttonObj.el.setAttribute('href', buttonObj.testHref);
							buttonObj.el.setAttribute('data-bi-download-name', buttonObj.testID);
							buttonObj.el.setAttribute('data-download-name', buttonObj.testID);
						});
					} else {
						btnArray.forEach(function(buttonObj) {
							buttonObj.el.setAttribute('href', buttonObj.defaultHref);
							buttonObj.el.setAttribute('data-bi-download-name', buttonObj.defaultID);
							buttonObj.el.setAttribute('data-download-name', buttonObj.defaultID);
						});
					}
				}

				// run consent check on load
				checkConsent(buttonsArray);

				//
				//  Listen to Cookie Consent changes
				//
				window.addEventListener('cheqCookieConsentHasChanged', function(event) {

					//
					//  DEV Only ––– Log event listener details
					//
					if (window.cheq.devMode) {
						console.group(window.cheq.helpers.getTimestamp() + ' –––– 🛜 🎯 🛜 🎯 🛜 🎯 🛜 🎯 🛜 🎯 🛜 🎯 🛜 🎯 🛜 🎯 🛜 🎯 🛜');
							console.log(window.cheq.helpers.getTimestamp() + ' –––– 🎯 Event RECEIVED in: /avast/j/v3/components/target-ab-download-ids.js –––– 3.0.5.K');
							console.log(window.cheq.helpers.getTimestamp() + ' –––– 📦 Event object: ', event);
							console.log(window.cheq.helpers.getTimestamp() + ' –––– 🍪 Consent data: ', event.detail.consent);
							console.log(window.cheq.helpers.getTimestamp() + ' –––– 🏹 Emitted at: ', event.detail.timestamp);
							console.log(window.cheq.helpers.getTimestamp() + ' –––– 🎯 Received at: ', window.cheq.helpers.getTimestamp());
						console.groupEnd();
					}

					//
					//  DEV Only ––– Log button download URLs ––– BEFORE consent check
					//
					if (window.cheq.devMode) {
						console.group(window.cheq.helpers.getTimestamp() + ' –––– buttonsArray –––– BEFORE checkConsent(...)');
							for (var i = 0; i < buttonsArray.length; i++) {
								console.log(buttonsArray[i].el.href);
							}
						console.groupEnd();
					}


					//
					//  Check consent
					//
					checkConsent(buttonsArray);


					//
					//  DEV Only ––– Log button download URLs ––– AFTER consent check
					//
					if (window.cheq.devMode) {
						console.group(window.cheq.helpers.getTimestamp() + ' –––– buttonsArray –––– AFTER checkConsent(...)');
							for (var i = 0; i < buttonsArray.length; i++) {
								console.log(buttonsArray[i].el.href);
							}
						console.groupEnd();
					}

				});

				// listener for pricebox update
				window.addEventListener('pricebox-updated', function(event) {
					event.detail.element.querySelectorAll(parameters.query).forEach(function(button){
						setButton(button);
						checkConsent(buttonsArray);
					})
				});


			} catch (error) {
				// singe data layer error tracking
				if (typeof sdl !== 'undefined') {
					console.error(error);
					sdl.push({
						system: {
							error: {
								type: error.name,
								message: error.message,
							}
						},
						event: 'system.error'
					})
				}
			}
		}
	};
}());
